import React from "react";
import { cn } from "./cn";

export function Card({ className, children, ...props }) {
  return (
    <div className={cn("rounded-2xl border border-line bg-surface shadow-card", className)} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children }) {
  return (
    <div className={cn("flex items-center justify-between gap-3 border-b border-line px-5 py-4", className)}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children }) {
  return <h3 className={cn("text-sm font-semibold text-ink", className)}>{children}</h3>;
}

export function CardBody({ className, children }) {
  return <div className={cn("p-5", className)}>{children}</div>;
}
